import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Group } from '@era/security-sdk';
import { MemberGroupStoreActions, MemberGroupStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { GroupItem, ListGroupItemsComponent } from './list-group-items.component';

@Component({
  selector: 'era-security-member-list-group-items',
  templateUrl: 'member-list-group-items.container.html',
  styleUrls: ['./member-list-group-items.container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ListGroupItemsComponent, AsyncPipe],
})
export class MemberListGroupItemsContainerComponent {
  private readonly store = inject(Store);

  public readonly isEditing = input(false);

  public readonly memberGroups$: Observable<Group[]> = this.store.select(
    MemberGroupStoreSelectors.selectCurrentGroupChildren
  );

  delete(selectedGroup: GroupItem) {
    this.store.dispatch(
      MemberGroupStoreActions.MemberGroupApiActions.memberGroupsGroupDeleted({
        group: selectedGroup as Group,
      })
    );
  }
}
